import React, {
    useState
} from 'react';

import { 
   IonPage,
   IonHeader,
   IonContent,
   IonToolbar,
   IonTitle,
   IonGrid,
   IonRow,
   IonCol,
   IonButtons,
   IonButton,
   IonBackButton,
   NavContext,
   IonImg,
   IonLoading,
   useIonRouter,
   useIonViewWillEnter
} from '@ionic/react';

import { hideTab } from "../components/Tabs";
import { Storage } from '@capacitor/storage';   
import NServer from "../components/NServer";
import { LANGUAGE, GetStr } from "../language/Language";
import { showAlert } from '../components/Alert';


type EmailConfirmData = {
    temp_id : any,
    temp_key : string
};

const ConfirmEmail : React.FC = () => 
{
    const [showLoading, setShowLoading] = useState(false);
    
    //	Initializing our router
	const router = useIonRouter();    

    useIonViewWillEnter(() => {
        hideTab();
    });

    // confirmation success
    const confirmSuccess = () => {
        router.push("/login", "back", "pop");
    }

    const checkComfirmation = async () => {
        
        setShowLoading(true);

        const id = await Storage.get({ key: "temp_id" });
        let temp_id = parseInt(id.value as string);
        
        const key = await Storage.get({ key: "temp_key" });
        let temp_key = key.value as string;

        const state = {
            temp_id: temp_id,
            temp_key: temp_key
        }
        
        var server = new NServer();
        await server.sendForm("check_confirm_email", state);

        setShowLoading(false);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            showAlert(GetStr(LANGUAGE.TXT_EMAIL_CONFIRM_SUS));
            confirmSuccess();
        }
    }

    const resendEmail = async () => {
        
        setShowLoading(true);

        const id = await Storage.get({ key: "temp_id" });
        let temp_id = parseInt(id.value as string);
        
        const key = await Storage.get({ key: "temp_key" });
        let temp_key = key.value as string;

        const state = {
            temp_id: temp_id,
            temp_key: temp_key
        }
        
        var server = new NServer();
        await server.sendForm("resend_email", state);

        setShowLoading(false);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
            showAlert(GetStr(LANGUAGE.TXT_RESEND_EMAIL_MSG));
    }
  

    return (
        <IonPage>
            <IonContent>
                <div id="border-bk" />
                <IonToolbar color="none">
                    <IonButtons slot="start">
                        <IonBackButton defaultHref="login" />
                    </IonButtons>
                </IonToolbar>
                <IonLoading
                    isOpen={showLoading}
                    onDidDismiss={() => setShowLoading(false)}
                    message={ GetStr(LANGUAGE.TXT_PLZ_WAIT) }
                />
                <IonGrid>
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-lg="8" size="11">
                            <h2>{ GetStr(LANGUAGE.TXT_CONFIRM_EMAIL_CAP) }</h2>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow> 
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol className="ion-padding" size-md="2" size="5">
                            <IonImg src="/assets/img/msg_pic.png" />
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow> 
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-lg="8" size="11">
                            { GetStr(LANGUAGE.TXT_CONFIRM_EMAIL_DESC) }
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow> 
                    <IonRow className="ion-padding-top">
                        <IonCol>
                        </IonCol>
                        <IonCol size-lg="6" size-md="8" size="11">
                            <IonButton className="main-but" color="primary" expand="block" onClick={checkComfirmation}>{ GetStr(LANGUAGE.TXT_CONFIRM_EMAIL_BUT) }</IonButton>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow> 
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-lg="6" size-md="8" size="11">
                            <IonButton size="small" fill="clear" onClick={resendEmail}>{ GetStr(LANGUAGE.TXT_RESEND_EMAIL) }</IonButton>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
};

export default ConfirmEmail;